import React, { useContext } from "react";
import AboutImg1 from "../../assets/images/new/banner1.jpeg";
import contactImg1 from "../../assets/images/new/whyc.jpg";
import MissionImg from "../../assets/images/new/targeting.png";
import VisionImg from "../../assets/images/new/vision.png";
import contactImg2 from "../../assets/images/new/4.jpg";
import contactImg3 from "../../assets/images/new/2.jpg";
import contactImg4 from "../../assets/images/new/conatus us.png";
import contactImg5 from "../../assets/images/shapes/about-1-shape-2.png";
import contactImg6 from "../../assets/images/shapes/about-1-shape-3.png";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import "./AboutUsPage.css";
import { useMediaQuery } from "@mui/material";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import Support from "../../Components/SupportComponent/Support";
import TestimonialsSection from "../../Components/TestimonialSection/Testimonial";
import batuk from "../../assets/images/new/aboutUsPageBatu.jpeg";
import batukone from "../../assets/images/new/fav-removebg-preview.png";
import { t } from "i18next";
import { LoaderContext } from "../../AuthContext/AuthContext";
const AboutUsPage = () => {
  const { selectedLanguageID } = useContext(LoaderContext);
  // const isMobileView = useMediaQuery({ maxWidth: 600 });
  return (
    <>
      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">{t("About Us")}</h2>
        </div>
      </section>
      <section className="about-us py-5 about-responsive">
        <div className="container">
          <div className="d-flex flex-column" style={{ width: "100%" }}>
            {/* Main Content */}
            <div className="d-flex flex-lg-row flex-column gap-3">

              {/* Image Section (Left on Desktop, After Content on Mobile) */}
              <div className="col-12 col-lg-5 order-2 order-lg-1">
                <div
                  className="about-one__image wow fadeInLeft"
                  data-wow-delay="100ms"
                >
                  <div className="about-one__image__one">
                    <img
                      src={batuk}
                      style={{
                        width: "100%",
                        objectFit: "contain",
                      }}
                      alt="about"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>

              {/* Content Section (First on Mobile, Right on Desktop) */}
              <div className="col-12 col-lg-7 order-1 order-lg-2">
                <article className="about-content content">
                  <div className="sec-title text-start">
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{
                        perspective: "400px",
                        display: "flex",
                        alignItems: "left",
                        justifyContent: "start",
                      }}
                    >
                      <img className="tagline-img" src={batukone} alt="" />
                      {t("About Us")}
                    </h6>
                    <h3
                      className="sec-title__title bw-split-in-left"
                      style={{ perspective: "400px", textAlign: "left" }}
                    >
                      {t("Who We Are")}
                    </h3>
                  </div>

                  <p className="text-dark">
                    {t("Myomnamo is a one-stop digital platform dedicated to fulfilling all your spiritual and religious needs. Rooted in tradition and powered by technology, we bring you seamless access to a wide range of services. With verified Pandits and temples, diverse rituals and language options, authentic spiritual products with secure delivery, and personalized spiritual experiences, Myomnamo ensures a trusted and meaningful journey for every devotee.")}
                  </p>

                  <ul>
                    <li>{t("Puja & Darshan Booking")}</li>
                    <li>{t("E-Store for Spiritual Essentials")}</li>
                    <li>{t("Daily Puja Services")}</li>
                    <li>{t("Horoscope & Astrology Services")}</li>
                    <li>{t("Puja & Darshan Booking")}</li>
                  </ul>

                  <p className="text-dark">
                    {t("Let Myomnamo guide your spiritual journey with devotion,authenticity, and ease.")}
                  </p>
                </article>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Download App  */}

      {/* Become a partner */}
      <Support />
      {/* Testonomial */}
      <TestimonialsSection />
      <DownloadApp languageID={selectedLanguageID == 3 ? 1 : null} />
    </>
  );
};

export default AboutUsPage;
